export function utilityVerificationGaps(utility) {
    // C4 wird gesetzt, nicht geworfen: keine Flugbahn, keine Wurfart, keine
    // Practice-Bilder — es gilt immer als verifiziert.
    if (utility.type === "C4")
        return {
            missingMedia: [],
            missingTrajectory: false,
            missingTechnique: false,
        };
    return {
        missingMedia: utility.frames
            .filter((frame) => !frame.media)
            .map((frame) => frame.kind),
        missingTrajectory: !utility.physics,
        missingTechnique: !utility.technique.trim() || utility.technique === "PLATZIERT",
    };
}
export function isUtilityVerifiable(utility) {
    const gaps = utilityVerificationGaps(utility);
    return (!gaps.missingMedia.length &&
        !gaps.missingTrajectory &&
        !gaps.missingTechnique);
}
